"use strict";

import { reactPlugin } from '@datadog/browser-rum-react';
export const datadogOptions = {
  applicationId: '683ef0cc-3951-45b7-ab78-65d2ed57e344',
  clientToken: 'pub76c5c96f3b3c38beced100a20853c001',
  site: 'ap2.datadoghq.com',
  service: 'autoguru-mfe-portals',
  env: 'production',
  version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
  trackingConsent: 'granted',
  plugins: [reactPlugin({
    router: false
  })],
  beforeSend: _event => true
};